import { Observable } from 'rxjs';
import * as ExcelJS from 'exceljs';

export abstract class Parser {
	public abstract parse(arrayBuffer: ArrayBuffer): Observable<ExcelJS.Workbook>;
}
